<template>
  <div class="wrapper col-md-10 mx-auto">
    <div class="panel">
      <top-navbar></top-navbar>

      <dashboard-content>

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style>
.card .card-header {
  background-color: rgb(231, 241, 252);
}
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus {
  background-color: #fff;
}
.formulate-form .card {
  padding-right: 0px;
  padding-left: 0px;
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
    },
    methods: {
    }
  }

</script>
